import { Box, Progress, Text, IconButton, Link, Image, Input, Button, InputGroup, InputRightElement } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calculateDateRange, quizListIsLoading, quizListLoadingSuccess, quizStarted, resetComments, resetQuizList, resetSelectedCourse, resetTopicAndQuiz, setAutocompleteVisibility, setHeaderText, setSelectedMenuItem, topicStartReset } from "../../redux/actions/action";
import { loadCourseComments, loadQuizQuestions, loadSelectedCourse, postComment } from "../../redux/api/apiCalls";
import { ReactComponent as Calendar } from '../../svg/calendar.svg'
import { ReactComponent as Certificate } from '../../svg/certificate.svg'
import { ReactComponent as PeopleEnrolled } from '../../svg/peopleEnrolled.svg'
import { ReactComponent as Favorite } from '../../svg/red-heart.svg'
import { ReactComponent as AverageTime } from '../../svg/clock.svg'
import { ReactComponent as Beginner } from '../../svg/beginner.svg'
import { ReactComponent as Intermediate } from '../../svg/intermediate.svg'
import { ReactComponent as Advanced } from '../../svg/advanced.svg'
import { ReactComponent as Comments } from '../../svg/comments.svg'
import TopicsList from "./TopicsList";
import QuizzesList from "./QuizzesList";
import { CloseIcon } from "@chakra-ui/icons";
import AlertMessage from "../common/AlertMessage";
import { useHistory } from "react-router";
import ReactPlayer from 'react-player'
const extensions = ['mp4', 'm1v', 'ogg', 'mov', 'qt', 'webm', 'm4v', 'wmv', 'avi']

export default function CourseDetails(props) {
    const { selectedCourse, isLoading/*, selectedCourseError*/ } = useSelector(state => state.selectedCourse)
    const { comments } = useSelector(state => state.commentsState)
    const { quiz_id } = useSelector(state => state.currentTopicAndQuizState)
    const [contentLink, setContentLink] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    const [commentsVisible, setCommentsVisible] = useState(false)
    const commentRef = useRef()
    const history = useHistory()
    const dispatch = useDispatch()

    const onClose = () => {
        setIsOpen(false)
        dispatch(resetTopicAndQuiz())
    }

    const getCourseFromParams = () => {
        dispatch(loadSelectedCourse(props.match.params.id))
        dispatch(loadCourseComments(props.match.params.id))
    }


    useEffect(() => {
        dispatch(setHeaderText('Courses'))
        dispatch(setSelectedMenuItem(1))
        dispatch(resetTopicAndQuiz())
        dispatch(topicStartReset())
        getCourseFromParams()
        return () => {
            dispatch(resetSelectedCourse())
            dispatch(resetQuizList())
            dispatch(resetComments())
        }
        // eslint-disable-next-line
    }, [])

    const filterQuizzes = () => {
        const inProgressAndCompletedTopics = selectedCourse.topics.filter(topic => topic.topic_completed_status === "C" || topic.topic_completed_status === 'I').map(topic => topic.id)
        dispatch(quizListIsLoading())
        if (inProgressAndCompletedTopics.length) {
            const visibleQuizzes = selectedCourse.quiz.filter(quiz => inProgressAndCompletedTopics.includes(Number(quiz.topic_id)))
            dispatch(quizListLoadingSuccess(visibleQuizzes))
        }
        else {
            dispatch(quizListLoadingSuccess([]))
        }
    }

    useEffect(() => {
        if (selectedCourse) {
            filterQuizzes()
        }
        // eslint-disable-next-line
    }, [selectedCourse])

    const contentCloseClickHandler = () => {
        setIsOpen(quiz_id ? true : false)
        setContentLink(null)
    }

    const attemptNowHandler = () => {
        dispatch(loadQuizQuestions(quiz_id))
        dispatch(quizStarted())
        history.push('/test-attempt')
    }

    const getIcon = (level) => {
        switch (level) {
            case 'Beginner':
                return <Beginner width='20px' height='20px' fill='#fa5953' />
            case 'Intermediate':
                return <Intermediate width='20px' height='20px' fill='#fa5953' />
            case 'Advanced':
                return <Advanced width='20px' height='20px' fill='#fa5953' />
            default:
                return
        }
    }

    const getRandomComment = () => {
        let randomNumber = Math.floor(Math.random() * comments.length)
        return `"${comments[randomNumber]["comment"]}" - ${comments[randomNumber].users.first_name} ${comments[randomNumber].users.last_name}`
    }

    const addCommentHandler = async () => {
        if (commentRef.current.value.trim().length === 0) {
            return
        }
        else {
            try {
                let response = await postComment(commentRef.current.value.trim(), props.match.params.id)
                if (response) {
                    commentRef.current.value = ''
                    dispatch(loadCourseComments(props.match.params.id))
                }
                else {
                    console.log("Something went wrong!")
                }
            }
            catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <Box
            px='1rem'
            w='95%'
            minH='90vh'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            {
                isLoading && !selectedCourse ? <Progress size='xs' isIndeterminate width='100%' mt='3rem' /> :
                    <>
                        <Box width='100%' d='flex' justifyContent='space-between' alignItems='flex-end'>
                            <Text
                                fontSize={['12px', '14px']}
                                fontWeight='600'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                pt='2rem'
                                color='#999999'
                                textTransform='capitalize'
                            >
                                Home/Course/{selectedCourse?.title}
                            </Text>

                            <Link href="#comments" style={{ textDecoration: 'none' }}>
                                <Box d='flex' alignItems='flex-end' justifyContent='center' cursor='pointer'>
                                    <Comments width='18px' height='18px' stroke="#08BD80" fill = "#08BD80" />
                                    <Text
                                        fontSize={['14px', '16px']}
                                        fontWeight='600'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                        pt='2rem'
                                        color='#08BD80'
                                        ml='2'
                                    >
                                        Comments
                                    </Text>
                                </Box>
                            </Link>
                        </Box>
                        <Text
                            fontSize={['20px', '25px', '30px', '40px']}
                            d='flex'
                            fontWeight='900'
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            textTransform='capitalize'
                        >
                            {selectedCourse?.title}
                        </Text>

                        <Box
                            d='flex'
                            style={{ fontFamily: 'Mulish, sans-serif', gap: '2rem' }}
                            fontSize={['14px', '14px', '14px', '15px', '16px']}
                            fontWeight='600'
                            justifyContent='space-between'
                            alignItems='center'
                            color='#666666'
                            width='100%'
                            flexWrap={['wrap', 'wrap', 'wrap', 'wrap', 'nowrap']}
                        >
                            <Box d='flex' justifyContent='center' alignItems='center'>
                                <Calendar />
                                <Text ml='2'>{calculateDateRange(selectedCourse ? selectedCourse.start_date : '2021/08/15', selectedCourse ? selectedCourse.end_date : '2021/08/15')}</Text>
                            </Box>
                            <Box d='flex' justifyContent='center' alignItems='center'>
                                <Certificate />
                                <Text ml='2'>Certificate</Text>
                            </Box>
                            <Box d='flex' justifyContent='center' alignItems='center'>
                                <PeopleEnrolled />
                                <Text ml='2'>People Enrolled</Text>
                            </Box>
                            <Box d='flex' justifyContent='center' alignItems='center'>
                                <AverageTime />
                                <Text ml='2'>Average Time : 5 hours</Text>
                            </Box>
                            <Box d='flex' justifyContent='center' alignItems='center'>
                                {getIcon(selectedCourse?.level)}
                                <Text ml='2'>{selectedCourse?.level}</Text>
                            </Box>
                            {
                                selectedCourse?.favourites ==='Yes' && 
                                <Box d='flex' justifyContent='center' alignItems='center' w='fit-content'>
                                    <Favorite />
                                    <Text ml='2' color='#222222'>Favorite</Text>
                                </Box>
                            }
                        </Box>
                        <Box
                            width='100%'
                            minH={contentLink ? '550px' : '0'}
                            maxH='600px'
                            d='flex'
                            transition='all 500ms linear'
                            position='relative'
                            objectFit='cover'
                            // paddingTop='2rem'
                            my='2rem'
                            borderRadius='10px'
                            boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                        >
                            {
                                contentLink &&
                                <>
                                    {
                                        !contentLink.includes('localhost') ?
                                            <>
                                                {!extensions.includes(contentLink.substring(contentLink.lastIndexOf('.') + 1)) ?
                                                    <iframe
                                                        title={contentLink?.substring(contentLink.lastIndexOf('/') + 11)}
                                                        src={contentLink}
                                                        alt={contentLink?.substring(contentLink.lastIndexOf('/') + 11)}
                                                        width='100%'
                                                        allowFullScreen
                                                        style={{ borderRadius: '10px', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)' }}
                                                    />
                                                    :
                                                    <ReactPlayer url={contentLink} controls={true} width='100%' height='550px' style={{ borderRadius: '12px' }} />
                                                }
                                            </> :
                                            <Text
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                fontSize='20px'
                                                fontWeight='800'
                                                color='#222222'
                                                width='100%'
                                                display='flex'
                                                justifyContent='center'
                                                alignItems='center'
                                            >
                                                Content Not Found
                                            </Text>
                                    }
                                </>
                            }
                            {
                                contentLink &&
                                <IconButton
                                    onClick={contentCloseClickHandler}
                                    icon={<CloseIcon />}
                                    variant='solid'
                                    size='xs'
                                    colorScheme='red'
                                    position='absolute'
                                    zIndex='2'
                                    top='1'
                                    right='1'
                                />
                            }
                        </Box>
                        <Box width='100%' my='2rem' position={['static', 'static', 'static', 'static', 'relative']} d='flex' flexDir={['column', 'column', 'column', 'column', 'row']} justifyContent='space-between'>
                            <TopicsList topics={selectedCourse?.topics} courseId={props.match.params.id} completed={selectedCourse?.completed_topics} total={selectedCourse?.total_topics} setContentLink={setContentLink} />
                            <QuizzesList courseId={props.match.params.id} completed={selectedCourse?.completed_quizz} total={selectedCourse?.total_quiz} />
                        </Box>
                        {
                            !contentLink &&
                            <Box
                                dangerouslySetInnerHTML={{ __html: selectedCourse?.description }}
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                lineHeight='32px'
                                my='1rem'
                                pl={selectedCourse?.description.includes('<li>') && '2rem'}
                            ></Box>
                        }

                        <Box id="comments" d='flex' alignItems='center' mb='1rem'>
                            <Comments fill="#08BD80" width='22px' height='22px' stroke = "#08BD80" />
                            <Text
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='18px'
                                fontWeight='400'
                                color='#08BD80'
                                lineHeight='32px'
                                ml='2'
                                cursor='pointer'
                                onClick={() => setCommentsVisible(!commentsVisible)}
                            >
                                {comments.length} Comments {commentsVisible ? `(click to hide)` : `(click to expand)`}
                            </Text>

                        </Box>
                        <Box d={!commentsVisible ? 'flex' : 'none'} px='1.5rem' mb='2rem'>
                            <Text fontSize='14px' fontWeight='400' color='#999999'><em>{comments.length > 0 && `${getRandomComment()}`}</em></Text>
                        </Box>

                        <Box
                            d={commentsVisible ? 'flex' : 'none'}
                            w='47.5%'
                            flexDir='column'
                            bg='#ffffff'
                            borderRadius='10px'
                            boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                            mb='2rem'
                        >
                            <Box
                                w='100%'
                                h={commentsVisible ? 'fit-content' : '0px'}
                                maxH='200px'
                                transition='height 300ms linear'
                                overflowY='auto'
                                d={commentsVisible ? 'flex' : 'none'}

                                flexDir='column'

                                padding='20px'
                                sx={{
                                    '&::-webkit-scrollbar': {
                                        width: '10px',
                                        borderRadius: '8px',
                                        backgroundColor: `transparent`,
                                        height: '90%',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: `rgba(0, 0, 0, 0.2)`,
                                        borderRadius: '20px'
                                    },
                                }}
                            >
                                {
                                    comments.length > 0 ? comments.map((comment, idx) => <Box key={idx} position='relative' d='flex' w='100%' justifyContent='flex-start' alignItems='center' mb={idx !== comments.length - 1 && '2rem'} pb='1rem'>
                                        <Image width='45px' height='45px' objectFit='cover' borderRadius='50%' src={comment.users.avatar} fallbackSrc={"https://source.unsplash.com/random/800x600"} alt={comment.users.first_name} />
                                        <Box
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            ml='1rem'
                                            d='flex'
                                            flexDir='column'
                                            justifyContent='center'
                                        >
                                            <Text fontSize='16px' mb='1' fontWeight='600' color='#00000099'>{comment.users.first_name} {comment.users.last_name}</Text>
                                            <Text fontSize='14px' fontWeight='400' color='#999999'><em>{comment.comment}</em></Text>
                                        </Box>
                                        <Box
                                            width='100%'
                                            height='1px'
                                            bg='rgba(0, 0, 0, 0.2)'
                                            position='absolute'
                                            bottom='0'
                                        ></Box>
                                    </Box>)
                                        :
                                        <Text fontSize='16px' mb='1' fontWeight='600' color='#00000099' textAlign='center'>No comments yet. Be the first one!</Text>
                                }
                            </Box>
                            <Box
                                d='flex'
                                w='100%'
                                alignItems='center'
                                px='5%'
                                pb='2'
                            >
                                <InputGroup>
                                    <Input
                                        ref={commentRef}
                                        type='text'
                                        fontSize='16px'
                                        fontWeight='600'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                        borderRadius='10px'
                                        h='40px'
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        bg='#fcfcfc'
                                        placeholder="Post a Comment..."
                                        pr='5rem'
                                    />
                                    <InputRightElement
                                        width='4.5rem'
                                        children={
                                            <Button
                                                fontSize='12px'
                                                size='md'
                                                py={['10px', '10px', '10px', '8px', '11px']}
                                                px={['18px', '18px', '18px', '15px', '19px']}
                                                bg='linear-gradient(95.45deg, rgba(70, 163, 70, 0.57) 0.98%, #4BBD4B 100%)'
                                                borderRadius='10px'
                                                textTransform='uppercase'
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                _hover={{ bg: 'linear-gradient(95.45deg, rgba(70, 163, 70, 0.57) 0.98%, #43aa42 100%)' }}
                                                color='#FFFFFF'
                                                fontWeight='800'
                                                onClick={addCommentHandler}
                                            >
                                                Post
                                            </Button>
                                        }
                                    />

                                </InputGroup>
                            </Box>
                        </Box>
                    </>
            }

            {/* {
                !isLoading && selectedCourseError && <Text>{selectedCourseError}</Text>
            } */}
            <AlertMessage
                isOpen={isOpen}
                onClose={onClose}
                text="Quiz!"
                message="Do you want to attempt the quiz now?"
                method={attemptNowHandler}
                AffirmativeButtonText="Play"
                AffirmativeButtonColor="#3E59DE"
                AffirmativeButtonHoverColor="#3750c6"
                CancelButtonText="Later"
                CancelButtonColor="#FF7251"
                CancelButtonHoverColor="#E56647"
            />
        </Box>
    )
}